var _metadata, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhoneIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "128.000000pt",
    height: "128.000000pt",
    viewBox: "0 0 128.000000 128.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, "\nCreated by potrace 1.16, written by Peter Selinger 2001-2019\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,128.000000) scale(0.100000,-0.100000)",
    fill: "#ff1940",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M154 1221 c-49 -32 -99 -69 -111 -82 -53 -58 -57 -149 -13 -279 129 -387 442 -701 828 -830 132 -44 223 -40 281 13 13 12 50 62 82 111 49 72 59 96 59 130 0 31 -6 48 -23 64 -27 25 -305 132 -344 132 -15 0 -55 -18 -90 -41 -44 -29 -69 -40 -86 -36 -68 18 -316 266 -334 334 -4 17 7 42 36 86 23 35 41 75 41 90 0 39 -107 317 -132 344 -16 17 -33 23 -64 23 -34 0 -58 -10 -130 -59z m165 -9 c14 -26 111 -287 111 -298 0 -5 -18 -36 -40 -69 -52 -78 -52 -112 -4 -184 53 -79 179 -207 258 -262 89 -63 118 -64 201 -9 33 22 64 40 69 40 11 0 272 -97 298 -111 10 -5 18 -20 18 -33 0 -35 -113 -202 -149 -220 -45 -24 -106 -19 -207 14 -366 122 -672 428 -794 794 -33 101 -38 162 -14 207 18 36 185 149 220 149 13 0 28 -8 33 -18z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/PhoneIcon.0a8267ca6eb695a18a38b5ac25f6ba84.svg";
export { ForwardRef as ReactComponent };